// extracted by mini-css-extract-plugin
module.exports = {"metrics_pm":"MemorandumValues_metrics_pm__3W_xI","column_metrics":"MemorandumValues_column_metrics__1C4Ye"};